import React, { useEffect, useMemo, useRef } from 'react'

import './DropdowSearch.scss'
import { getLength } from 'commons/function'

const arrDataTemp = [
  { id: 1, name: 'Item 1' },
  { id: 2, name: 'Item 2' },
  { id: 3, name: 'Item 3' },
]

function DropdownSearch({
  placeholder = 'Search...',
  arrData = [],
  // onSearch,
  // value,
  onChoose,
}) {
  const inputRef = useRef()
  const inputSearchRef = useRef()

  const [isShowDropdown, setShowDropdown] = React.useState(false)
  const [value, setValue] = React.useState('')
  const [itemChoose, setItemChoose] = React.useState(null)

  const resultData = useMemo(() => {
    const dataTemp = arrData
    let resultSearch = []

    if (value) {
      const searchValue = value.toLowerCase()
      resultSearch = dataTemp.filter((item) =>
        item.name.toLowerCase().includes(searchValue)
      )
    } else {
      resultSearch = dataTemp
    }

    return resultSearch
  }, [arrData, value])

  const onShowDropdown = () => {
    setShowDropdown(!isShowDropdown)
  }

  const onChooseItem = (item) => () => {
    setShowDropdown(false)
    setItemChoose(item)
    if (onChoose) {
      onChoose(item)
    }
  }

  useEffect(() => {
    if (inputRef.current) {
      if (isShowDropdown) {
        setTimeout(() => {
          inputRef.current.focus()
        }, 100)
      } else {
        inputRef.current.blur()
      }
    }

    const handleClickOutside = (event) => {
      if (
        inputSearchRef.current &&
        !inputSearchRef.current.contains(event.target)
      ) {
        setShowDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isShowDropdown, inputRef])

  return (
    <div className='dropdown-search' ref={inputSearchRef}>
      <div className='dropdown-search__input' onClick={onShowDropdown}>
        {isShowDropdown ? (
          <input
            type='text'
            ref={inputRef}
            className='dropdown-search__input-field'
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        ) : (
          <span
            className={`dropdown-search__input-placeholder ${
              !itemChoose &&
              'dropdown-search__input-placeholder--text-placeholder'
            }`}>
            {itemChoose?.logo && (
              <img
                src={itemChoose?.logo}
                alt={itemChoose?.name}
                className='logo-img'
              />
            )}

            {itemChoose ? itemChoose.name : placeholder}
          </span>
        )}

        <span className='icon-web_arrow_down arrow-down'></span>
      </div>
      <div
        className={`dropdown-search__results ${
          isShowDropdown && 'dropdown-search__results--show'
        }`}>
        {/* Results will be populated here */}
        <div className='result-wrapper'>
          <div className='result-content'>
            {getLength(resultData) > 0 ? (
              resultData.map((item, i) => {
                const isLink = item.link

                if (isLink) {
                  return (
                    <a
                      href={item.link}
                      target='_blank'
                      className='content-item'
                      rel='noopener noreferrer nofollow'
                      key={i}>
                      <img
                        src={item.logo}
                        alt={item.name}
                        className='content-item__logo'
                      />

                      {item.name}
                    </a>
                  )
                } else {
                  return (
                    <div
                      className='content-item'
                      key={i}
                      onClick={onChooseItem(item)}>
                      <img
                        src={item.logo}
                        alt={item.name}
                        className='content-item__logo'
                      />
                      {item.name}
                    </div>
                  )
                }
              })
            ) : (
              <div className='content-item content-item--empty'>
                No result found
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropdownSearch
